class SearchByMake extends HTMLElement {
  connectedCallback() {
    const make = new URLSearchParams(
      window.location.search
    ).get('make');

    if (!make) return;

    const target = this.querySelector('[data-car-make]');

    if (target) {
      const brandUppercased = make
        .replace(/-/g, ' ').toUpperCase()
      target.textContent = `${brandUppercased} Wipers`;
    }

    document.addEventListener(
      'vrmSearchMakesReady',
      () => {
        document.dispatchEvent(
          new CustomEvent('carMakeSelected', {
            detail: { make }
          })
        );
      },
      { once: true }
    );
  }
}

if (!customElements.get('search-by-make')) {
  customElements.define(
    'search-by-make',
    SearchByMake
  );
}